import React from 'react';
import { Text } from 'components/shared/uniform';

export default () => {
  return (
    <Text level="small" color="nonessential">—</Text>
  );
};
